import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalContext, ViewerContext, Button, toast } from "dash-ui";
import { createGlobalStyle } from "styled-components";

import { useCreateSimpleBrokerMutation } from "gql/generated.graphql";

// If this is useful in any other context, extract it to a component
export const ModalOverlayBlur = createGlobalStyle`
  .blurred-modal__overlay,
  .blurred-modal__overlay--after-open {
    height: 100% !important;
    background: rgba(0, 0, 0, 0.4) !important;
    backdrop-filter: blur(6px);
    /* For Safari support */
    -webkit-backdrop-filter: blur(6px);
    transition: backdrop-filter 0.3s;
  }
`;

const ConfirmUserTypeModal = ({}) => {
  // Hooks
  const { t } = useTranslation("pages");
  const [isSeeker, setIsSeeker] = useState<boolean | null>(null);
  const { isOpenCurrent, toggleModal } = useContext(ModalContext);
  const { broker } = useContext(ViewerContext);

  // This modal should be open only if there is no broker for the current account yet
  const isOpen = isOpenCurrent["ConfirmUserTypeModal"] && !broker;

  const [createSimpleBrokerMutation, { loading }] =
    useCreateSimpleBrokerMutation();

  const handleUserTypeResponse = (isSeeker: boolean) => {
    setIsSeeker(isSeeker);
    createSimpleBrokerMutation({
      variables: {
        input: {
          isSeeker,
        },
      },
      onCompleted: () => {
        toggleModal(false, "ConfirmUserTypeModal");
        window.location.reload();
      },
      onError: (error) => {
        console.error("Failed to create broker:", error);
        // Do NOT reload on error: the modal reopens automatically while the
        // account still has no broker, so a blind reload here turns a transient
        // failure into an infinite reload loop (DSH-880). Surface the error and
        // let the user retry instead — createSimpleBroker is idempotent on the
        // backend, so re-submitting is safe.
        toast.error(t("confirmUserType.setupError"));
      },
    });
  };

  return (
    <Modal
      closeIcon
      isOpen={isOpen}
      viewHierarchy={1}
      maxWidth={"90%"}
      className="blurred-modal"
      p={10}
      w="fit-content"
    >
      <>
        <ModalOverlayBlur />
        <div>
          <h3 className="text-2xl font-[Montserrat] mb-4 text-center">
            {t("confirmUserType.title")}
          </h3>
          <h4 className="text-slate-500 text-sm text-center">
            {t("confirmUserType.subtitle")}
          </h4>
          <div className="flex flex-row w-full gap-4 mt-8">
            <Button
              w={"100%"}
              variation="primary"
              px={3}
              isLoading={loading && !isSeeker}
              disabled={loading}
              onClick={(e) => {
                e.preventDefault();
                handleUserTypeResponse(false);
              }}
            >
              {t("confirmUserType.yes")}
            </Button>
            <Button
              w={"100%"}
              variation="outline"
              px={3}
              isLoading={loading && !!isSeeker}
              disabled={loading}
              onClick={(e) => {
                e.preventDefault();
                handleUserTypeResponse(true);
              }}
            >
              {t("confirmUserType.no")}
            </Button>
          </div>
        </div>
      </>
    </Modal>
  );
};

export default ConfirmUserTypeModal;
